import * as zod from 'zod'

const caption = zod.string().trim().max(128)

const story = zod.string().trim().max(9999)

const took = zod.date()

const rating = zod.number().nullable()

const location = zod.string().regex(/^\s*([-\d.]+\s*,\s*[-\d.]+)?\s*$/)

const tags = zod.array(zod.object({
  value: zod.string(),
  label: zod.string(),
}))

export const UpdateFotoSchema = zod.object({caption, story, took, rating, location, tags})
export type UpdateFotoSchema = zod.infer<typeof UpdateFotoSchema>
